/* ── CHRIS 3D TILT ── */
const cv=document.getElementById("cvis"),c3=document.getElementById("c3d"),cg=document.getElementById("cg");
if(cv&&c3){
  cv.addEventListener("mousemove",e=>{
    const r=cv.getBoundingClientRect();
    const dx=((e.clientX-r.left)/r.width-.5)*2,dy=((e.clientY-r.top)/r.height-.5)*2;
    gsap.to(c3,{rotateY:dx*15,rotateX:-dy*11,transformPerspective:900,duration:.45,ease:"power2.out"});
    if(cg){const gx=50+dx*28,gy=50+dy*28;cg.style.background=`radial-gradient(circle at ${gx}% ${gy}%,rgba(255,255,255,.18) 0%,transparent 60%)`;cg.style.opacity="1";}
  });
  cv.addEventListener("mouseleave",()=>{
    gsap.to(c3,{rotateY:0,rotateX:0,duration:.8,ease:"power3.out"});
    if(cg)cg.style.opacity="0";
  });
  gsap.from(c3,{scrollTrigger:{trigger:cv,start:"top 75%"},rotateY:-22,x:-50,opacity:0,duration:1.2,ease:"power3.out"});
}